/**
 * If you use this function, the controller needs an instance of:
 * - $scope on the scope property
 * - $injector on the injector property
 * - a allowRoute property (you don't have to initialize it, but on leaving page, you have to set it to true)
 * @param controller
 * @param callback (if set, should be callable)
 */

export default function askToArchiveContact(contact, injector) {

    const $translate = injector.get('$translate'),
        alert = injector.get('Alert'),
        translatedValue = (path, params) => {
            return $translate.instant(`contacts.helpers.ask-to-archive-contact.${path}`, params);
        };

    return alert.animatedAlert(
        translatedValue('title'),
        translatedValue('content', {contact_name: contact.full_name || contact.first_name + ' ' + contact.last_name}),
        'attention',
        {
            confirmButtonText: translatedValue('confirm'),
            cancelButtonText: translatedValue('cancel'),
            wait: true
        }).then(() => {
        return injector.get('$http').delete(`contacts/${contact.id}`).then(() => {
            alert.hide();
            return alert.success('Success', `${contact.full_name} archived`);
        }, err => alert.handle(err));
    }, err => alert.handle(err));
}



// WEBPACK FOOTER //
// ./src/app/modules/contacts/helpers/ask-to-archive-contact.js